
const PaymentService = {
  async generateCheckoutForm({id, email, price, language, params = ""}) {
    //return_url = payment_completed + params
    const payload = {
      id,
      email,
      price,
      language,
      return_url: `https://billo.be/payment-completed${params}`,
    };

    const url = `${process.env.VUE_APP_WORLDLINE_API_URL}/payments/billoCheckout?access_token=${process.env.VUE_APP_WORLDLINE_API_TOKEN}`;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    const responseData = await response.json();
    if (
      !response.ok ||
      !responseData.status ||
      !responseData.data?.checkout?.redirectUrl
    ) {
      const error = new Error(
        responseData.error_description || "Failed to initiate payment.",
      );
      throw error;
    }
    window.location.href = responseData.data.checkout.redirectUrl;
  },
  async checkPaymentStatus(hostedCheckoutId) {
    const url = `${process.env.VUE_APP_WORLDLINE_API_URL}/payments/checkoutStatus?id=${hostedCheckoutId}&profile=HUUREENSTUUR&access_token=${process.env.VUE_APP_WORLDLINE_API_TOKEN}`;
    const response = await fetch(url);
    const responseData = await response.json();
    if (!response.ok || !responseData.status) {
      const error = new Error(
        responseData.error_description || "Failed to fetch payment status.",
      );
      throw error;
    }
    return responseData.data;
  },
};

export default PaymentService;
